import { createSlice } from '@reduxjs/toolkit'

export interface IContractHistoryState {
  entries: any[]
  isLoading: boolean
  error: null | string
}

const initialState: IContractHistoryState = {
  entries: [],
  isLoading: false,
  error: null
}

export const contractHistorySlice = createSlice({
  name: 'contract history',
  initialState,
  reducers: {
    // START LOADING
    startHistoryLoading: (state) => {
      state.isLoading = true
      state.entries = []
      state.error = null
    },
    // SET HISTORY SUCCESS
    setHistory: (state, action) => {
      state.isLoading = false
      state.entries = action.payload.entries.reverse()
      state.error = null
    },
    // SET HISTORY ERROR
    historyError: (state, action) => {
      state.isLoading = false
      state.error = action.payload
      state.entries = []
    },
    // CLEAR HISTORY
    clearContractHistory: (state) => {
      state.isLoading = false
      state.entries = []
      state.error = null
    }
  }
})

export const { startHistoryLoading, setHistory, historyError, clearContractHistory } = contractHistorySlice.actions
export default contractHistorySlice.reducer
